var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('label',{staticClass:"racq-checkbox-container",attrs:{"aria-disabled":"true"}},[_c('input',{attrs:{"type":"checkbox","disabled":""},domProps:{"checked":_vm.value ? 'checked' : ''}}),_c('span',{staticClass:"checkmark"})])}
var staticRenderFns = []

export { render, staticRenderFns }